import { useEffect } from "react";

const useClickAway = (refObj: React.RefObject<HTMLElement>, callback: () => void) => {
  const handleClickAway = (e: MouseEvent) => {
    if(!(refObj?.current?.contains(e.target as Node))) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickAway);
    return () => document.removeEventListener('click', handleClickAway);
  }, []);
}

export default useClickAway;